import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { InvitationItem } from "../invitation.schemas";
import type { SendFriendInvitationsResult } from "../invitation.types";

export type SendFriendInvitationsPayload = {
  invitationId: number;
  invitees: InvitationItem[];
};

export type UseSendFriendInvitationsArgs = {
  onSuccess?: (data: SendFriendInvitationsResult) => void;
  onError?: (error: Error) => void;
};

/**
 * Mutation hook for sending friend invitations.
 * Pass invitationId and invitees at mutation time.
 */
export function useSendFriendInvitations({
  onSuccess,
  onError,
}: UseSendFriendInvitationsArgs = {}) {
  return useMutation({
    mutationFn: async ({
      invitationId,
      invitees,
    }: SendFriendInvitationsPayload) => {
      return await apiRequest("/invitation/send/", "POST", {
        invitation_id: invitationId,
        invitees: invitees.map((invitee) => ({
          email: invitee.email,
          first_name: invitee.firstName,
          last_name: invitee.lastName,
        })),
      });
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error: Error) => {
      onError?.(error);
      throw error;
    },
  });
}

export default useSendFriendInvitations;
